const defauleImageSize = 1 * 50000 * 1024 // 50MB

export { defauleImageSize }